(function () {
  function withSpaceThousands(value) {
    return value.replace(/(\d)\.(\d{3})/g, "$1\u00a0$2");
  }

  function reformatPrices(root) {
    if (!root) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue && /\d\.\d{3}/.test(node.nodeValue)) {
        node.nodeValue = withSpaceThousands(node.nodeValue);
      }
    }
  }

  function schedulePriceFix() {
    reformatPrices(document.body);
  }

  document.addEventListener("DOMContentLoaded", schedulePriceFix);
  document.addEventListener("cart:rerendered", schedulePriceFix, true);
  document.addEventListener("theme:loading:end", schedulePriceFix);

  var STORAGE_KEY = "fb-cart-reserve-until";
  var overlayObserver = null;

  function cartEl() {
    return document.getElementById("mini-cart");
  }

  function overlayEl() {
    return document.querySelector(".mini-cart-overlay");
  }

  function itemCount() {
    var cart = cartEl();
    return cart ? parseInt(cart.getAttribute("data-item-count"), 10) || 0 : 0;
  }

  function reserveMinutes() {
    var banner = document.querySelector("[data-reserve-minutes]");
    var minutes = banner ? parseInt(banner.getAttribute("data-reserve-minutes"), 10) : 5;
    return isNaN(minutes) || minutes < 1 ? 5 : minutes;
  }

  function pad(value) {
    return value < 10 ? "0" + value : String(value);
  }

  function deadline(count) {
    if (!count) {
      try { sessionStorage.removeItem(STORAGE_KEY); } catch (e) {}
      return null;
    }

    var until = null;
    try { until = parseInt(sessionStorage.getItem(STORAGE_KEY), 10); } catch (e) {}

    if (!until || until < Date.now()) {
      until = Date.now() + reserveMinutes() * 60 * 1000;
      try { sessionStorage.setItem(STORAGE_KEY, String(until)); } catch (e) {}
    }

    return until;
  }

  function tickTimer() {
    var cart = cartEl();
    if (!cart) return;

    var count = itemCount();
    var banner = cart.querySelector(".mini-cart__urgency");
    var timers = cart.querySelectorAll(".mini-cart__timer");

    if (!count) {
      if (banner) banner.hidden = true;
      deadline(0);
      return;
    }

    if (banner) banner.hidden = false;

    var remaining = Math.max(0, (deadline(count) || Date.now()) - Date.now());
    if (remaining === 0) {
      try { sessionStorage.removeItem(STORAGE_KEY); } catch (e) {}
      remaining = Math.max(0, (deadline(count) || Date.now()) - Date.now());
    }

    var text = Math.floor(remaining / 60000) + ":" + pad(Math.floor((remaining % 60000) / 1000));
    timers.forEach(function (node) {
      node.textContent = text;
    });
  }

  function syncOpenState() {
    var cart = cartEl();
    var overlay = overlayEl();
    var open = !!(cart && cart.getAttribute("aria-hidden") === "false");

    document.body.classList.toggle("mini-cart-open", open);

    if (overlay) {
      if (open) overlay.removeAttribute("hidden");
      else overlay.setAttribute("hidden", "");
    }
  }

  function observeCart() {
    var cart = cartEl();
    if (!cart || overlayObserver) return;

    overlayObserver = new MutationObserver(syncOpenState);
    overlayObserver.observe(cart, { attributes: true, attributeFilter: ["aria-hidden"] });
    syncOpenState();
  }

  function changeSellingPlan(input) {
    var line = parseInt(input.getAttribute("data-line"), 10);
    var quantity = parseInt(input.getAttribute("data-quantity"), 10) || 1;
    var sellingPlan = input.checked ? input.getAttribute("data-selling-plan") : "";

    document.dispatchEvent(new CustomEvent("theme:loading:start"));

    fetch((window.routes && window.routes.cartChangeUrl ? window.routes.cartChangeUrl : "/cart/change") + ".js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest"
      },
      body: JSON.stringify({
        line: line,
        quantity: quantity,
        selling_plan: sellingPlan || null
      })
    }).then(function () {
      document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
        bubbles: true,
        detail: { scrollToTop: false }
      }));
    }).catch(function () {
      document.dispatchEvent(new CustomEvent("theme:loading:end"));
    });
  }

  document.addEventListener("change", function (event) {
    var input = event.target.closest("[data-action='toggle-selling-plan']");
    if (input) changeSellingPlan(input);
  });

  function formatEuroFromCents(cents) {
    var parts = (Math.abs(cents) / 100).toFixed(2).split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, "\u00a0");
    return parts.join(",") + "\u00a0€";
  }

  function collectAlmaNodes(root, acc) {
    if (!root) return acc;
    var all = root.querySelectorAll ? root.querySelectorAll("*") : [];
    for (var i = 0; i < all.length; i++) {
      acc.push(all[i]);
      if (all[i].shadowRoot) collectAlmaNodes(all[i].shadowRoot, acc);
    }
    return acc;
  }

  function isTenXLabel(el) {
    if (!el || el.closest && (el.closest("[data-alma-open]") || el.closest(".alma-10x__line"))) return false;
    var t = (el.innerText || el.textContent || "").replace(/\s+/g, " ").trim();
    if (!t || t.length > 28) return false;
    return /^(10\s*x|10x|10\s*fois)$/i.test(t) || /(^|\s)10\s*x(\s|$)/i.test(t);
  }

  function clickAlma10xTab() {
    var nodes = collectAlmaNodes(document, []);
    for (var i = 0; i < nodes.length; i++) {
      if (!isTenXLabel(nodes[i])) continue;
      var clickable = nodes[i].closest("button, [role='tab'], [role='button'], a, label, li") || nodes[i];
      if (clickable && typeof clickable.click === "function") {
        clickable.click();
        return true;
      }
    }
    return false;
  }

  function almaWidgetHost() {
    return document.querySelector('[data-block-id*="alma_widget"], .jg-alma-host, [class*="alma-widget"]');
  }

  function openAlma10xPopup(e) {
    if (e) e.preventDefault();
    var host = almaWidgetHost();
    if (host) {
      host.classList.add("is-alma-open");
      var trigger = host.querySelector("button, a, [role='button']") || host;
      if (host.shadowRoot) {
        trigger = host.shadowRoot.querySelector("button, a, [role='button']") || trigger;
      }
      if (trigger && typeof trigger.click === "function") trigger.click();
      [80, 250, 600, 1200].forEach(function (ms) {
        setTimeout(clickAlma10xTab, ms);
      });
      var obs = new MutationObserver(function () { clickAlma10xTab(); });
      obs.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { obs.disconnect(); }, 2500);
      return;
    }
    var fallback = document.querySelector("[data-alma-fallback]");
    if (fallback && fallback.showModal) fallback.showModal();
  }

  document.addEventListener("click", function (e) {
    var open = e.target.closest("[data-alma-open]");
    if (open) openAlma10xPopup(e);
    if (e.target.closest("[data-alma-close]")) {
      var d = e.target.closest("dialog");
      if (d && d.close) d.close();
    }
  });

  function fillAlmaSchedules() {
    var months = ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"];
    document.querySelectorAll("[data-alma-schedule]").forEach(function (ol) {
      if (ol.getAttribute("data-filled")) return;
      var first = parseInt(ol.getAttribute("data-first"), 10);
      var rest = parseInt(ol.getAttribute("data-rest"), 10);
      if (!first || !rest) return;
      var now = new Date();
      var html = "";
      for (var i = 0; i < 10; i++) {
        var d = new Date(now.getFullYear(), now.getMonth() + i, now.getDate());
        var label = i === 0 ? "Aujourd'hui" : d.getDate() + " " + months[d.getMonth()] + " " + d.getFullYear();
        html += "<li><span>" + label + "</span> <strong>" + formatEuroFromCents(i === 0 ? first : rest) + "</strong></li>";
      }
      ol.innerHTML = html;
      ol.setAttribute("data-filled", "1");
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    observeCart();
    tickTimer();
    setInterval(tickTimer, 250);
    fillAlmaSchedules();
  });

  document.addEventListener("cart:rerendered", function () {
    overlayObserver = null;
    observeCart();
    tickTimer();
    syncOpenState();
    schedulePriceFix();
  }, true);

  var searchOpenUntil = 0;
  document.addEventListener("focusin", function (e) {
    if (e.target && e.target.classList && e.target.classList.contains("search-bar__input")) {
      var wrap = e.target.closest(".header__search-bar-wrapper");
      if (wrap) wrap.classList.add("is-opening");
      searchOpenUntil = Date.now() + 500;
      setTimeout(function () {
        if (wrap) wrap.classList.remove("is-opening");
      }, 500);
    }
  }, true);
  document.addEventListener("click", function (e) {
    if (Date.now() >= searchOpenUntil) return;
    if (e.target.closest && e.target.closest(".search-bar") && !e.target.closest('[data-action="unfix-search"]')) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
  }, true);

  function alignHuelMega(menu) {
    if (!menu || menu.getAttribute("aria-hidden") !== "false") return;
    menu.style.marginLeft = "0px";
    menu.style.width = "100vw";
    var left = menu.getBoundingClientRect().left;
    menu.style.marginLeft = -left + "px";
    menu.style.width = document.documentElement.clientWidth + "px";
  }

  function syncMegaMenuState(menu) {
    if (!menu) return;
    var open = menu.getAttribute("aria-hidden") === "false";
    if (open) {
      menu.removeAttribute("inert");
      alignHuelMega(menu);
    } else {
      menu.setAttribute("inert", "");
      menu.style.marginLeft = "";
      menu.style.width = "";
    }
  }

  document.querySelectorAll(".mega-menu--huel").forEach(function (menu) {
    syncMegaMenuState(menu);
    if ("MutationObserver" in window) {
      new MutationObserver(function () {
        syncMegaMenuState(menu);
      }).observe(menu, { attributes: true, attributeFilter: ["aria-hidden"] });
    }
  });

  document.addEventListener("mouseover", function (e) {
    var tab = e.target.closest("[data-mega-tab]");
    if (tab) {
      var menu = tab.closest(".mega-menu--huel");
      if (menu && menu.getAttribute("aria-hidden") === "false") {
        var id = tab.getAttribute("data-mega-tab");
        menu.querySelectorAll("[data-mega-tab]").forEach(function (el) {
          el.classList.toggle("is-active", el === tab);
        });
        menu.querySelectorAll("[data-mega-panel]").forEach(function (panel) {
          panel.classList.toggle("is-active", panel.getAttribute("data-mega-panel") === id);
        });
      }
    }

    var item = e.target.closest(".nav-bar__item");
    if (item) {
      var opened = item.querySelector(".mega-menu--huel[aria-hidden='false']");
      if (opened) alignHuelMega(opened);
    }
  }, true);

  window.addEventListener("resize", function () {
    document.querySelectorAll(".mega-menu--huel[aria-hidden='false']").forEach(alignHuelMega);
  });
})();
